import React from 'react';
import styles from './InspirationCard.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

interface Props {
  clickCallback: () => void;
  disabled: boolean;
}

const AddInspirationCard: React.FC<Props> = ({ clickCallback, disabled }) => {
  const didClick = () => {
    if (!disabled) {
      clickCallback();
    }
  };

  return (
    <div className="col-12 col-md-6  d-flex flex-row ps-3 col-lg-4 col-xl-3 mb-4">
      <div className={`${styles.card} col-12  col-md-6 col-lg-3 position-relative`}>
        <div className={`${styles.cardInfoWrapper} d-flex flex-column  bg-light`}>
          <div className={`${styles.imageWrapper}`}>
            <div className={` ${disabled ? styles.addButtonDisabled : styles.addButton}`} style={disabled ? {} : { cursor: 'pointer' }} onClick={didClick}>
              <FontAwesomeIcon icon={faPlus as IconProp} style={{ fontSize: '4rem' }} className="color-light" />
            </div>
            {/* <ActionButton
            label="Save as favorite"
            icon="heart"
            position="top-right"
            action={() => alert('Added as favorite')}
          /> */}
          </div>

          <div className={`${styles.cardInfoContent} container bg-light`}>
            <div className="row h-25 mt-2 mb-3 mx-1">
              <div className="col text-center align-self-center">
                <h3 className="fw-bold color-blue d-sm-none d-md-block ">Add inspiration</h3>
                <h1 className="fw-bold color-blue d-md-none d-sm-block">Add inspiration</h1>
              </div>
            </div>

            <div className=" col align-self-center text-justify py-3 px-4">
              Share with the community what inspires you in your design and earn extra reputation points for your profile
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddInspirationCard;
